"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable @typescript-eslint/no-non-null-assertion */
var connected_react_router_1 = require("connected-react-router");
var react_1 = __importDefault(require("react"));
var react_device_detect_1 = require("react-device-detect");
var react_dom_1 = __importDefault(require("react-dom"));
var App_1 = __importDefault(require("./App"));
var _state_1 = __importDefault(require("./_state"));
var actions_1 = require("./features/auth/state/actions");
var FooterProvider_1 = __importDefault(require("./features/dashboard/components/footer/FooterProvider"));
var constants_1 = require("./shared/constants");
var log_1 = __importDefault(require("./shared/log"));
var AuthApi = __importStar(require("@app/services/api/auth"));
var render = function () {
    if (react_device_detect_1.isMobileSafari) {
        var appElement = document.getElementById('app');
        if (appElement) {
            appElement.classList.add('mobile-safari');
        }
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_dom_1.default.render(react_1.default.createElement(App_1.default, { store: _state_1.default }), document.getElementById('app')),
        react_dom_1.default.render(react_1.default.createElement(FooterProvider_1.default, { store: _state_1.default }), document.getElementById('mobile-footer'))));
};
var sessionStorageTransfer = function (event) { return __awaiter(void 0, void 0, void 0, function () {
    var jwt, verifedJwt, data, _i, _a, key, verifedJwt;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                event = event || window.event;
                if (!event.newValue) {
                    return [2 /*return*/];
                }
                if (!(event.key === 'getSessionStorage')) return [3 /*break*/, 3];
                // Triggers the 'storage' event in another tab and sends the current tab's sessionStorage over
                localStorage.setItem('sessionStorage', JSON.stringify(sessionStorage));
                // The other tab should now have it, so we can delete this.
                localStorage.removeItem('sessionStorage');
                jwt = sessionStorage.getItem(constants_1.JWT_STORAGE_KEY);
                if (!jwt) return [3 /*break*/, 2];
                return [4 /*yield*/, AuthApi.verifyAuth(jwt)];
            case 1:
                verifedJwt = _b.sent();
                if (!verifedJwt) {
                    log_1.default.debug('JWT has expired');
                    _state_1.default.dispatch(actions_1.expireBlastSession());
                }
                _b.label = 2;
            case 2: return [3 /*break*/, 10];
            case 3:
                if (!(event.key === 'sessionStorage' && !sessionStorage.length)) return [3 /*break*/, 9];
                data = JSON.parse(event.newValue);
                if (!data) return [3 /*break*/, 8];
                _i = 0, _a = Object.keys(data);
                _b.label = 4;
            case 4:
                if (!(_i < _a.length)) return [3 /*break*/, 8];
                key = _a[_i];
                if (!(key === constants_1.JWT_STORAGE_KEY)) return [3 /*break*/, 6];
                return [4 /*yield*/, AuthApi.verifyAuth(data[key])];
            case 5:
                verifedJwt = _b.sent();
                if (verifedJwt) {
                    sessionStorage.setItem(key, data[key]);
                }
                return [3 /*break*/, 7];
            case 6:
                sessionStorage.setItem(key, data[key]);
                _b.label = 7;
            case 7:
                _i++;
                return [3 /*break*/, 4];
            case 8: return [3 /*break*/, 10];
            case 9:
                if (event.key === constants_1.LOGOUT_TRIGGER_KEY) {
                    _state_1.default.dispatch(actions_1.logout(false));
                    _state_1.default.dispatch(connected_react_router_1.push('/login'));
                    // window.location.assign('/login');
                }
                else if (event.key === constants_1.BLAST_ACTIVITY) {
                    _state_1.default.dispatch(actions_1.refreshActivityAction(new Date(event.newValue)));
                }
                _b.label = 10;
            case 10: return [2 /*return*/];
        }
    });
}); };
// Called whenever sessionStorage or localStorage is modified int the context of another document (tab)
window.addEventListener('storage', sessionStorageTransfer, false);
// Trigers the window 'storage' event which initiates the copy of sessionStorage from one tab to the next
if (!sessionStorage.length) {
    localStorage.setItem('getSessionStorage', (new Date().getTime()).toString());
    localStorage.removeItem('getSessionStorage');
}
// Introduce a slight delay before rendering to make sure sessionStorage is fully loaded from another tab
setTimeout(function () {
    render();
}, 500);
// React hot module loading. Whenever a src file changes, re-render the root App component
if (module.hot) {
    module.hot.accept('./App', function () {
        render();
    });
}
